(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        if (isLargeScreen) {
          this.disclosure.open = true;
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.disclosure.open = false;
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        if (!(this.matches('.js-mega-nav') && isLargeScreen)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);

    // Force navigation details elements to be open on desktop (but not product page accordions)
    function setDetailsOpenState() {
      const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
      // Only target navigation details elements, not product page accordions or mega content sections
      document
        .querySelectorAll(
          'nav details:not(.mega-content-collapsible), .header details:not(.mega-content-collapsible), .mega-nav details:not(.mega-content-collapsible)'
        )
        .forEach((details) => {
          details.open = isLargeScreen;
        });
    }

    // Set initial state
    setDetailsOpenState();

    // Update on resize
    window.addEventListener('on:breakpoint-change', setDetailsOpenState);
  });

  // Locale selector functionality
  document.addEventListener('DOMContentLoaded', function () {
    const localeSelector = document.getElementById('locale-selector');
    const localeBtn = localeSelector?.querySelector('.header__locale-btn');
    const localeDropdown = document.getElementById('locale-dropdown');

    if (!localeSelector || !localeBtn || !localeDropdown) {
      return;
    }

    // Toggle dropdown
    localeBtn.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isExpanded = localeBtn.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          closeLocaleDropdown();
        } else {
          openLocaleDropdown();
        }
      },
      true
    ); // Use capture phase to run before other handlers

    // Prevent dropdown from closing when clicking inside it
    localeDropdown.addEventListener('click', function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    });

    function openLocaleDropdown() {
      localeDropdown.classList.remove('hidden');
      localeBtn.setAttribute('aria-expanded', 'true');

      localeDropdown.style.display = 'block';

      // Focus first option for accessibility
      const firstOption = localeDropdown.querySelector('.header__locale-option');
      if (firstOption) {
        firstOption.focus();
      }
    }

    function closeLocaleDropdown() {
      localeDropdown.classList.add('hidden');
      localeDropdown.style.display = '';
      localeBtn.setAttribute('aria-expanded', 'false');
    }

    // Simple outside click handler - clean and simple now that programmatic clicks are fixed
    document.addEventListener('click', function (e) {
      // Only process if dropdown is open
      if (localeDropdown.classList.contains('hidden')) {
        return;
      }

      // Check if click is outside BOTH the locale selector AND the dropdown
      const clickedOnSelector = localeSelector.contains(e.target);
      const clickedOnDropdown = localeDropdown.contains(e.target);

      if (!clickedOnSelector && !clickedOnDropdown) {
        closeLocaleDropdown();
      }
    });

    // Close dropdown on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !localeDropdown.classList.contains('hidden')) {
        closeLocaleDropdown();
        localeBtn.focus();
      }
    });

    // Handle keyboard navigation in dropdown
    localeDropdown.addEventListener('keydown', function (e) {
      const options = Array.from(localeDropdown.querySelectorAll('.header__locale-option'));
      const currentIndex = options.indexOf(document.activeElement);

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          const nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
          options[nextIndex].focus();
          break;
        case 'ArrowUp':
          e.preventDefault();
          const prevIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
          options[prevIndex].focus();
          break;
        case 'Home':
          e.preventDefault();
          options[0].focus();
          break;
        case 'End':
          e.preventDefault();
          options[options.length - 1].focus();
          break;
      }
    });

    // Mobile navigation "see more" functionality
    document.querySelectorAll('.mobile-dropdown__item--see-more').forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const expandableList = this.closest('.mobile-nav-expandable');
        if (expandableList) {
          expandableList.classList.toggle('expanded');
        }
      });
    });

    // Also use event delegation for dynamically created elements
    document.addEventListener('click', function (e) {
      if (
        e.target.matches('.mobile-dropdown__item--see-more') ||
        e.target.closest('.mobile-dropdown__item--see-more')
      ) {
        e.preventDefault();
        e.stopPropagation();

        const button = e.target.matches('.mobile-dropdown__item--see-more')
          ? e.target
          : e.target.closest('.mobile-dropdown__item--see-more');
        const expandableList = button.closest('.mobile-nav-expandable');

        if (expandableList) {
          expandableList.classList.toggle('expanded');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variable-header"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        if (isLargeScreen) {
          this.disclosure.open = true;
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.disclosure.open = false;
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        if (!(this.matches('.js-mega-nav') && isLargeScreen)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);

    // Force navigation details elements to be open on desktop (but not product page accordions)
    function setDetailsOpenState() {
      const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
      // Only target navigation details elements, not product page accordions or mega content sections
      document
        .querySelectorAll(
          'nav details:not(.mega-content-collapsible), .header details:not(.mega-content-collapsible), .mega-nav details:not(.mega-content-collapsible)'
        )
        .forEach((details) => {
          details.open = isLargeScreen;
        });
    }

    // Set initial state
    setDetailsOpenState();

    // Update on resize
    window.addEventListener('on:breakpoint-change', setDetailsOpenState);
  });

  // Locale selector functionality
  document.addEventListener('DOMContentLoaded', function () {
    const localeSelector = document.getElementById('locale-selector');
    const localeBtn = localeSelector?.querySelector('.header__locale-btn');
    const localeDropdown = document.getElementById('locale-dropdown');

    if (!localeSelector || !localeBtn || !localeDropdown) {
      return;
    }

    // Toggle dropdown
    localeBtn.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isExpanded = localeBtn.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          closeLocaleDropdown();
        } else {
          openLocaleDropdown();
        }
      },
      true
    ); // Use capture phase to run before other handlers

    // Prevent dropdown from closing when clicking inside it
    localeDropdown.addEventListener('click', function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    });

    function openLocaleDropdown() {
      localeDropdown.classList.remove('hidden');
      localeBtn.setAttribute('aria-expanded', 'true');

      localeDropdown.style.display = 'block';

      // Focus first option for accessibility
      const firstOption = localeDropdown.querySelector('.header__locale-option');
      if (firstOption) {
        firstOption.focus();
      }
    }

    function closeLocaleDropdown() {
      localeDropdown.classList.add('hidden');
      localeDropdown.style.display = '';
      localeBtn.setAttribute('aria-expanded', 'false');
    }

    // Simple outside click handler - clean and simple now that programmatic clicks are fixed
    document.addEventListener('click', function (e) {
      // Only process if dropdown is open
      if (localeDropdown.classList.contains('hidden')) {
        return;
      }

      // Check if click is outside BOTH the locale selector AND the dropdown
      const clickedOnSelector = localeSelector.contains(e.target);
      const clickedOnDropdown = localeDropdown.contains(e.target);

      if (!clickedOnSelector && !clickedOnDropdown) {
        closeLocaleDropdown();
      }
    });

    // Close dropdown on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !localeDropdown.classList.contains('hidden')) {
        closeLocaleDropdown();
        localeBtn.focus();
      }
    });

    // Handle keyboard navigation in dropdown
    localeDropdown.addEventListener('keydown', function (e) {
      const options = Array.from(localeDropdown.querySelectorAll('.header__locale-option'));
      const currentIndex = options.indexOf(document.activeElement);

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          const nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
          options[nextIndex].focus();
          break;
        case 'ArrowUp':
          e.preventDefault();
          const prevIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
          options[prevIndex].focus();
          break;
        case 'Home':
          e.preventDefault();
          options[0].focus();
          break;
        case 'End':
          e.preventDefault();
          options[options.length - 1].focus();
          break;
      }
    });

    // Mobile navigation "see more" functionality
    document.querySelectorAll('.mobile-dropdown__item--see-more').forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const expandableList = this.closest('.mobile-nav-expandable');
        if (expandableList) {
          expandableList.classList.toggle('expanded');
        }
      });
    });

    // Also use event delegation for dynamically created elements
    document.addEventListener('click', function (e) {
      if (
        e.target.matches('.mobile-dropdown__item--see-more') ||
        e.target.closest('.mobile-dropdown__item--see-more')
      ) {
        e.preventDefault();
        e.stopPropagation();

        const button = e.target.matches('.mobile-dropdown__item--see-more')
          ? e.target
          : e.target.closest('.mobile-dropdown__item--see-more');
        const expandableList = button.closest('.mobile-nav-expandable');

        if (expandableList) {
          expandableList.classList.toggle('expanded');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
